module.exports = __webpack_public_path__ + "img/Bonaire.26a6a0ad.svg";